/* Solvea — bandeau du haut : défilement continu, sans flèches.
   Le motif est dupliqué jusqu'à couvrir deux fois la largeur visible,
   puis translaté d'exactement une largeur de motif : la boucle est invisible. */
(function () {
  'use strict';

  function monter(zone) {
    if (!zone || zone.dataset.slvPret === '1') return;
    var piste = zone.querySelector('[data-slv-ticker-piste]');
    var motif = zone.querySelector('[data-slv-ticker-motif]');
    if (!piste || !motif) return;

    var pas = motif.scrollWidth;
    if (!pas) return;

    zone.dataset.slvPret = '1';

    var large = zone.clientWidth || 0;
    var copies = Math.max(2, Math.ceil((large * 2) / pas));
    if (copies > 12) copies = 12;
    for (var i = 1; i < copies; i++) piste.appendChild(motif.cloneNode(true));

    var vitesse = parseInt(zone.dataset.slvVitesse, 10) || 70;
    piste.style.setProperty('--slv-ticker-pas', pas + 'px');
    piste.style.animationDuration = (pas / vitesse).toFixed(2) + 's';
    zone.setAttribute('data-slv-actif', '1');
  }

  function tout() {
    document.querySelectorAll('[data-slv-ticker]').forEach(monter);
  }

  /* Recalcul après rotation d'écran ou chargement des polices :
     la largeur du motif change, donc le pas de translation aussi. */
  function relancer() {
    document.querySelectorAll('[data-slv-ticker]').forEach(function (zone) {
      var piste = zone.querySelector('[data-slv-ticker-piste]');
      var motifs = zone.querySelectorAll('[data-slv-ticker-motif]');
      if (!piste || motifs.length === 0) return;
      for (var i = motifs.length - 1; i > 0; i--) piste.removeChild(motifs[i]);
      zone.dataset.slvPret = '';
      zone.removeAttribute('data-slv-actif');
      piste.style.animationDuration = '';
      monter(zone);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(relancer).catch(function () {});
  }

  var minuteur;
  window.addEventListener('resize', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(relancer, 250);
  });

  document.addEventListener('shopify:section:load', tout);
})();
